<script lang="ts">
  import clsx from 'clsx';
  import { Image } from '@athena-lib/Image';
  import { urlsAreEqual } from '@athena-lib/url';
  import { User } from '@athena-lib/Icons';
  import { Link } from '@athena-lib/Link';
  import ShoppingCartWithCount from '@athena-lib/ShoppingCartWithCount/ShoppingCartWithCount.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { getLoginContext } from '@athena-lib/loginContext.svelte';
  import { DrawerButton, SearchButton } from '..';
  import type { NewMenuProps } from './types';
  import { splitItems } from './utils';
  import ShipTo from './ShipTo.svelte';

  const {
    items,
    stickerAppLogoUrl,
    currentUrl,
    class: className,
    openDrawer,
    openSearch,
    itemsInCart,
    onCheckoutClick,
    onDeliveryDetailsClick,
    postalCode,
    onAccountClick,
  }: NewMenuProps = $props();
  const { isLoggedIn } = $derived(getLoginContext());

  const { leftSideMenu, rightSideMenu } = $derived(splitItems(items));
  const translations = getCommonTranslations();
</script>

<nav
  aria-label={translations.mainMenu}
  class={clsx('flex w-full items-center justify-around px-3', className)}
>
  <ul class="flex w-full items-center justify-start gap-8">
    <li class="flex items-center text-st-white">
      <DrawerButton
        sizeClass="h-8 w-8"
        label={translations.menu}
        onClick={openDrawer}
        displayLabel
      />
    </li>
    <li class="text-st-white">
      <SearchButton label={translations.searchToggle} onClick={openSearch} />
    </li>
    {#each leftSideMenu as item}
      <li>
        <a
          class={clsx(
            'py-1 text-base font-extrabold tracking-wider text-st-white hover:border-b-2 hover:border-st-yellow',
            urlsAreEqual(currentUrl?.pathname, item.link?.href ?? '') &&
              'border-b-2 border-st-yellow',
          )}
          href={item.link?.href}
        >
          {item.text}
        </a>
      </li>
    {/each}
  </ul>
  <Link href="/" class="px-8">
    <Image src={stickerAppLogoUrl} alt="Sticker App" />
  </Link>
  <ul class="flex w-full items-center justify-end">
    {#each rightSideMenu as item}
      <li class="border-r border-st-gray-700 px-4 text-sm">
        <a
          class={clsx(
            'py-1 text-sm text-st-gray-300',
            urlsAreEqual(currentUrl?.pathname, item.link?.href ?? '') &&
              'border-b-2 border-st-yellow',
          )}
          href={item.link?.href}
        >
          {item.text}
        </a>
      </li>
    {/each}
    <li class="border-r border-st-gray-700 px-4 text-sm text-st-gray-300">
      <ShipTo onClick={onDeliveryDetailsClick} {postalCode} />
    </li>
    <li class="flex items-center gap-6 px-4 text-sm text-st-gray-300">
      <button
        type="button"
        class="flex items-center gap-2"
        onclick={onAccountClick}
        aria-label={translations.account}
        data-sveltekit-reload
      >
        <User sizeClass="size-4" />
        <span>{isLoggedIn ? translations.account : translations.signIn}</span>
      </button>
      <ShoppingCartWithCount
        sizeClass="h-8 w-8"
        countPromise={itemsInCart}
        onClick={onCheckoutClick}
      ></ShoppingCartWithCount>
    </li>
  </ul>
</nav>
